import { DateTime } from 'luxon';

export default function isValueGreater(valueOne: any, valueTwo: any) {
  if (!valueOne) {
    return false;
  }

  if (!valueTwo) {
    return true;
  }

  if (
    DateTime.fromISO(valueOne).isValid &&
    DateTime.fromISO(valueTwo).isValid
  ) {
    return DateTime.fromISO(valueOne) > DateTime.fromISO(valueTwo);
  }

  if (typeof valueOne === 'string' && typeof valueTwo === 'string') {
    return valueOne.localeCompare(valueTwo) === 1;
  }

  if (typeof valueOne === 'number' && typeof valueTwo === 'number') {
    return valueOne > valueTwo;
  }

  throw new Error(
    'Incorrect value passed to isValueGreater.  Pass a date string, string, or number.',
  );
}
